import EmailConfirmation from './components';

export default EmailConfirmation;
